import React, { memo } from 'react';
import { DialogActions, Typography, Button } from '@mui/material';

interface ModalFooterProps {
  count: number;
  label: string;
  onClose: () => void;
  py?: number;
  buttonSize?: 'small';
}

const ModalFooter: React.FC<ModalFooterProps> = ({ count, label, onClose, py = 2, buttonSize }) => (
  <DialogActions sx={{ px: 3, py, bgcolor: 'background.default', borderTop: 1, borderColor: 'divider' }}>
    <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
      {count} {label}
    </Typography>
    <Button onClick={onClose} variant="outlined" size={buttonSize}>
      Close
    </Button>
  </DialogActions>
);

export default memo(ModalFooter);
